<template>
  <div class="error-container">
    <div class="error-box">
      <h1>Paramètre requis manquant</h1>
      <p>L'accès à l'application nécessite le code client dans l'URL.</p>
      <p>La source d'entrée et le type de régime sont optionnels.</p>
      <ul>
        <li><strong>Code client</strong> (requis) : ex: <code>fedex_rt</code>, <code>fedex_express</code>, <code>afeji</code>, etc...</li>
        <li><strong>Source d'entrée</strong> (optionnel) : <code>espace_assure</code>, <code>app</code> (par défaut: <code>espace_assure</code>)</li>
        <li><strong>Type de régime</strong> (optionnel) : <code>regime-general</code>, <code>alsace-moselle</code></li>
      </ul>
      <div class="example">
        <p>Exemples d'URL correctes :</p>
        <ul>
          <li><code>https://www.vivinter.fr/simulateur-garanties-sante/fedex_rt</code></li>
          <li><code>https://www.vivinter.fr/simulateur-garanties-sante/fedex_rt/app</code></li>
          <li><code>https://www.vivinter.fr/simulateur-garanties-sante/fedex_rt/espace_assure/regime-general</code></li>
          <li><code>https://www.vivinter.fr/simulateur-garanties-sante/fedex_rt/app/regime-general</code></li>
        </ul>
      </div>
      <p class="error-message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "MissingParameters",
  data() {
    return {
      message: "Veuillez vérifier votre URL et vous assurer qu'elle contient le code client.",
    };
  },
};
</script>

<style scoped>
.error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.error-box {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 1000px;
  text-align: center;
}

h1 {
  color: #dc3545;
  margin-bottom: 20px;
  font-size: 2rem;
}

p {
  color: #555;
  line-height: 1.6;
  margin-bottom: 15px;
}

ul {
  text-align: left;
  margin: 0;
  padding-left: 20px;
  color: #555;
}

li {
  margin-bottom: 10px;
}

code {
  background-color: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: monospace;
  color: #d63384;
}

.example {
  background-color: #f8f9fa;
  padding: 15px;
  border-left: 4px solid #f07d00;
  margin: 20px 0;
  text-align: left;
  border-radius: 4px;
}

.error-message {
  color: #dc3545;
  font-style: italic;
  margin-top: 25px;
}
</style>
